import { convertHelpers } from "global/common/convert";
import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { SportsSeasonContext } from "projectSpecific/sports/cnr/contexts/SportsSeasonContext";
import { _sportsOriginTypes } from "projectSpecific/sports/cnr/reducers/SportsReducer";
import { useContext, useEffect, useMemo, useState } from "react";
import { DatabaseContext } from "../../../global/cnr/contexts/DatabaseContext";
import { _showAppLogs } from "../../../global/cnr/contexts/LogContext";
import { ParentContext } from "../../../global/cnr/contexts/ParentContext";
import { useCacheDataManager } from "../../../global/cnr/contexts/useHelpers/cacheDataManager";
import { useMultiDoc } from "../../../global/cnr/contexts/useHelpers/useMultiDoc";
import { _sportsInfoTypes } from "./useSportsInfo";
import { _cacheGroupTypes } from "../../../global/cnr/contexts/useHelpers/useTimestamp";
import { dataItems_sportsSeasonResults } from "projectSpecific/sports/cnr/reducers/SportsSeasonReducer";
import { seasonalHelpers } from "../cnr/reducers/reducerHelpers/seasonalHelpers";

export const _matchSeasonalCollection = 'matches_seasonal'

const _applyCache = false

export const useSportResults = ({ sportsInfoType }) => {

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state, page_state, currentSettings_state } = states ?? {}

  const { handleGet_multiDocs } = useMultiDoc()

  const cdm = useCacheDataManager()

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, seasonMatches_info } = sportsSeason_state ?? {};

  const { view, pathViews } = paps_state ?? {}
  const { events: eventKey, sports: sportsKey } = pathViews ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  // pageContext 
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { sportPermissions } = aps_global ?? {}

  const { viewItems: viewItems_page } = aps_page ?? {}

  let viewItem = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}

  const { dataSource } = viewItem ?? {}
  const { dataParents, useSeasonals } = dataSource ?? {}

  const [sportsResults, setSportsResults] = useState({})

  // Guard to prevent multiple fetches
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    setInitialized(false);
  }, [eventKey]);

  useEffect(() => {
    if (!pathViews || !database_fns || initialized || !pathViews.events) return;
    if (sportsInfoType === _sportsInfoTypes.sportsSeason && !sportsKey) return;

    setInitialized(true);

    (async () => {

      const additionalDataParents = []

      const pkcProps = {
        pathViews,
        dataParents,
        additionalDataParents,
        data_cache: {},
        database_fns,
        ignoreCache_all: true,
      }

      const cache_groupType = _cacheGroupTypes.sportsResultsInfo;

      /**
       * handles the returned data from _refPath_s
       * @param {object} sport 
       */
      const handleSet_sport = (sport) => {

        const { latestSeason } = sport ?? {}

        const _pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])

        const cb_sportsResults = (sportsResultsData, pdks) => {
          const sportsSeason_datas = seasonalHelpers.ammend_sportsSeasonDataz(sportsResultsData, latestSeason)
          sportsSeason_datas.parentDataKeys = pdks
          setSportsResults(sportsSeason_datas)
        }
        handleGet_multiDocs({ key: 'sportsResults', sportsDocs: dataItems_sportsSeasonResults, pathViews, pks: _pks, callback: cb_sportsResults })

      }

      try {
        const cached_sportSeason = await cdm.getSubItem(cache_groupType, sportsKey);
        if (_applyCache && !_.isEmpty(cached_sportSeason)) {
          // _showAppLogs.sportInfo && console.log(`♻️💾 Loaded sports results from cache (${cache_groupType}-${sportsKey})`);
          setSportsResults(cached_sportSeason)
          return;
        }
        const _refPath_s = createRefPath_event(pathViews, ['sports', sportsKey])
        _showAppLogs.sportInfo && console.log(`🔥➡️ Fetching sports results from database (${_refPath_s})`);
        database_fns.get_doc({ refPath: _refPath_s, callback: handleSet_sport })
      } catch (err) {
        console.error(`❌ Failed to fetch event data`, err);
      }
    })();
  }, [sportsKey]);

  // ------------------- Memoized stable return -------------------
  const sportsResultsInfo = useMemo(
    () => (sportsResults),
    [sportsResults]
  );

  return sportsResultsInfo;

}; 